import { Directive, effect, input } from '@angular/core';
import { CriteriaObj } from '@src/suite/common/data-models/criteria/criteria-obj';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

import { AbstractAdornerDirective } from './abstract-adorner';

@Directive({
    selector: '[st-left-border]',
})
export class CardLeftBorderDirective extends AbstractAdornerDirective {
    styleProp = input('background-color');

    constructor() {
        super();
        effect(() => {
            if (this.styleProp()) {
                this.applyAdorner();
            }
        });
    }

    protected get locationID(): string {
        // TODO: Add Location IDs for Stories and Rundowns
        if (this.data()?.Type === ObjectTypes.ASSIGNMENT) {
            return this.globalTablesService.adornersIDS.AssignmentCardLeftBorder;
        }
        return this.globalTablesService.adornersIDS.TopicCardLeftBorder;
    }

    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj; adorner: Adorner }) {
        if (vcToApply && vcToApply.adorner && vcToApply.adorner.Color) {
            this.renderer.setStyle(this.el.nativeElement, this.styleProp(), vcToApply.adorner.Color);
        } else if (this.data()?.Type === ObjectTypes.ASSIGNMENT) {
            const assignmentType = (this.data() as StorytellingAssignmentRecord)?.PSTCoverageType.toUpperCase();
            const predefinded = this.predefinedIconsMap[assignmentType];
            if (predefinded) {
                this.renderer.setStyle(this.el.nativeElement, this.styleProp(), predefinded.color);
            } else {
                this.renderer.setStyle(this.el.nativeElement, this.styleProp(), '#DBDBDB');
            }
        } else {
            this.renderer.setStyle(this.el.nativeElement, this.styleProp(), '#DBDBDB');
        }
    }
}
